import { render } from "./AddWebhook.vue?vue&type=template&id=f218227c"
import script from "./AddWebhook.vue?vue&type=script&lang=js"
export * from "./AddWebhook.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__